module.exports = require("rxjs");


//////////////////
// WEBPACK FOOTER
// external "rxjs"
// module id = 7
// module chunks = 0